import type { ReactElement } from 'react';
import { DialogClose } from '@radix-ui/react-dialog';

export const DestinationHeader = ({
  onClose
}: {
  onClose: (value: boolean) => void;
}): ReactElement => {
  return (
    <>
      <div className='flex items-center gap-18 p-8'>
        {/* Chevron left */}
        <DialogClose onClick={() => onClose(false)} className='cursor-pointer'>
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className='duration-200 text-light transition-colors hover:text-primary'
          >
            <path
              d='M15 18L9 12L15 6'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </DialogClose>
        <div className='leading-normal text-xl font-demibold text-light'>Add RTMP Destination</div>
      </div>
    </>
  );
};
